import { render, staticRenderFns } from "./RequestTestingPlaceholder.vue?vue&type=template&id=1a943977&scoped=true"
import script from "./RequestTestingPlaceholder.vue?vue&type=script&lang=js"
export * from "./RequestTestingPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./RequestTestingPlaceholder.vue?vue&type=style&index=0&id=1a943977&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a943977",
  null
  
)

export default component.exports